<!-- Author: Wilson Pilco Nunez -->
<!-- Email: wilsonaux1@gmail.com -->
<!-- Created at: 2026-08-23 17:10 -->
<!-- Description:  -->
<template>
  <div>
    <form @submit.prevent="save">
      <div class="form-group">
        <label for="">Tipo de liquidación</label>
        <LiquidationTypeSelect v-model="type_id"></LiquidationTypeSelect>
      </div>
      <div class="form-group">
        <label for="">Concepto</label>
        <input type="text" class="form-control" v-model="concept" max="500" />
      </div>
      <div class="form-group">
        <label for="">Razon de egreso</label>
        <SelectReason ref="elSelRea" v-model="reason_id"></SelectReason>
      </div>
      <div class="form-group">
        <label for="">Empleado</label>
        <EmployeeSelect ref="elEmployeeSelect" v-model="employee_id"></EmployeeSelect>
      </div>
      <div class="form-group">
        <label for="">Monto</label>
        <app-input-money
          :quantity.sync="amount"
          :moneyCode="1"
        ></app-input-money>
      </div>
      <app-button-submit></app-button-submit>
    </form>
  </div>
</template>
<script>
import SelectReason from "../reasons/Select.vue";
import EmployeeSelect from "../employees/EmployeeSelect.vue";
import LiquidationTypeSelect from "./LiquidationTypeSelect.vue";
import AdminService  from "../AdminService.js";

const rules = {}
export default {
  name: "LiquidationForm",
  components: {
    SelectReason,
    EmployeeSelect,
    LiquidationTypeSelect
  },

  // directives

  props: {
    disabled: { default: false },
  },

  data: () => ({
    sending: false,
    id: null,
    concept: "",
    reason_id: 0,
    employee_id: 0,
    amount: 0,
    type_id: 0
  }),

  computed: {
    errors() { return false; }
  },

  // watch: {},

  mounted() {
    //
  },

  methods: {
    save() {
      this.sending = true;
      AdminService.saveLiquidations(this.$data).then(() => {
        this.$emit("submitted");
      });
    },
    reset() {
      this.sending = false;
      this.id = null;
      this.concept = "";
      this.reason_id = 0;
      this.employee_id = 0;
      this.amount = 0;
      this.type_id = 0;
      this.$refs.elSelRea.reset();
    },
    load(liquidationId) {
      AdminService.getLiquidation(liquidationId).then(data => {
        this.id = data.id;
        this.concept = data.concept;
        this.reason_id = data.reason_id;
        this.employee_id = data.employee_id;
        this.amount = data.amount;
        this.type_id = data.type_id;
        this.$refs.elSelRea.setValue(this.reason_id);
      });
    },
    setValue() {},
  }
};
</script>
<style scoped></style>

